import DDT from "@/pages/DDT/DDT.vue";

import { createBreadCrumbs, setNavigator } from "@/router/routerFunction";


export function routesDDT() {
  return [
    {
      path: "/ddt",
      name: "DDTit",
      component: DDT,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "DDT",
            url: "",
          },
        ],
        indexRoute: "ddt",
        permissions: ["ddt"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/ddt",
      name: "DDTen",
      component: DDT,
      meta: {
        breadcrumbs: [
          {
            name: "management",
            url: "",
          },
          {
            name: "DDT",
            url: "",
          },
        ],
        indexRoute: "ddt",
        permissions: ["ddt"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
  ]
}